import React, { useEffect, useMemo } from 'react';
import { Gallery as GalleryAtom, GalleryContext, useGalleryContext } from '@yme/atoms/gallery';
import { Col, Container, Row } from '@yme/atoms/grid';
import { IndentWrapper } from '@yme/components/Separator';
import { GALLERY_CONFIG } from './constants';
import { prepareGalleryData } from './helpers';
export function Gallery({ videos, images, isRemoveBottomIndent, }) {
    const galleryContext = useGalleryContext();
    const { setGalleryData } = galleryContext;
    const items = useMemo(() => prepareGalleryData(videos, images), [images, videos]);
    useEffect(() => {
        setGalleryData(items);
    }, [items, setGalleryData]);
    if (!items.imagesList || !items.imagesList.length) {
        return null;
    }
    return (React.createElement(IndentWrapper, { isRemoveBottomIndent: isRemoveBottomIndent },
        React.createElement(Container, null,
            React.createElement(Row, { justifyContent: "center" },
                React.createElement(Col, { lg: 8, md: 8 },
                    React.createElement(GalleryContext.Provider, { value: galleryContext },
                        React.createElement(GalleryAtom, { config: GALLERY_CONFIG })))))));
}
Gallery.displayName = 'Gallery_AEMComponent';
